<template>
<div class="surveillance-rea-explaur-modal">
  <modal v-model="reaExplaurModal"
         :footer="false"
         size="lg"
         :title="`${surveillance.establishment.name} - SPIADI ${surveillance.year}`">
    <div v-if="reaExplaurModal && surveillance" class="rea-explaur-modal">
      <h2>Module <span class="label label-reaExplaur">RÉA-explAUR</span></h2>
      <div v-if="status === 0">
        <alert type="info">
          <h3>
            Établissement inscrit au module<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            L'utilisateur doit remplir le formulaire de destinataire des
            écouvillons ainsi que les fiches services.
          </p>
        </alert>
      </div>
      <div v-else>
        <alert v-if="status === 1" type="warning">
          <h3>
            En attente des écouvillons<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            L'utilisateur a rempli le formulaire de destinataire des
            écouvillons et attend leur envoi. Les fiches services
            ont également été remplies.
          </p>
          <p>
            <btn type="warning" @click="reset" :disabled="busy">
              Réinitialiser
            </btn>
            <btn type="success" @click="notifySent" :disabled="busy">
              Écouvillons envoyés
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 2" type="success">
          <h3>
            Écouvillons envoyés<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            En attente de confirmation de réception.
          </p>
          <p>
            <btn type="info" @click="notifyReceived" :disabled="busy">
              Écouvillons reçus par l'établissement
            </btn>
          </p>
        </alert>
        <alert v-else-if="status === 3" type="info">
          <h3>
            Écouvillons reçus par l'établissement<br>
            <small>le {{ date }}</small>
          </h3>
          <p>
            Étude en cours
          </p>
        </alert>
        <hr>
        <h3>Destinataire des écouvillons</h3>
        <table class="table table-responsive">
          <tbody>
            <tr>
              <td>Nom</td>
              <td>{{ dest.firstName }} {{ dest.name }}</td>
            </tr>
            <tr>
              <td>Fonction</td>
              <td>{{ dest.role }}</td>
            </tr>
            <tr>
              <td>Établissement</td>
              <td>{{ dest.establishment }}</td>
            </tr>
            <tr>
              <td>Service</td>
              <td>{{ dest.service }}</td>
            </tr>
            <tr>
              <td>Adresse</td>
              <td>{{ dest.address }}</td>
            </tr>
          </tbody>
        </table>
        <hr>
        <h3>Services surveillés</h3>
        <table class="table table-responsive">
          <tbody>
            <tr v-for="(u, k) in units" :key="`unit-${k}`">
              <td>{{u.name}} ({{u.code}})</td>
              <td>{{u.beds}} lits surveillés</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import { confirm } from '@/sui/tools/modal'
import units from '@/sui/data/units'
import moment from 'moment'

export default {
  name: 'surveillance-rea-explaur-modal',

  props: {
    surveillance: Object,

    value: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      reaExplaurModal: this.value,
      busy: true
    }
  },

  watch: {
    reaExplaurModal: {
      handler () {
        this.$emit('input', this.reaExplaurModal)
      },
      deep: true
    },

    value: function (value) {
      this.reaExplaurModal = value
    },

    surveillance: function (s) {
      this.updateFromSurveillance(s)
    }
  },

  mounted: function () {
    if (this.surveillance != null) {
      this.updateFromSurveillance(this.surveillance)
    }
  },

  methods: {
    updateFromSurveillance: function (s) {
      this.busy = false
    },

    confirm: function (action, status) {
      confirm(
        this,
        `<h3>Changement de statut
<span class='label-bigger label label-reaExplaur'>RÉA-explAUR</span></h3>
<p class="text-justify">
Êtes vous sûr.e de vouloir changer le statut de l'établissement
<strong>${this.surveillance.establishment.name}</strong> en
<strong>«${action}»</strong> ?</p>`
      ).then(() => {
        this.setStatus(status)
      })
    },

    setStatus: function (status) {
      const request = {
        id: this.surveillance.id,
        stat: status,
        year: this.surveillance.year
      }
      const vm = this
      vm.busy = true
      this.$store.dispatch('surveillances/updateReaExplaurStatus', request).then(
        r => {
          if (r.data.err != null) {
            vm.busy = false
            vm.$notify(
              {
                type: 'danger',
                title: 'Erreur !',
                duration: 0,
                content: `Une erreur s'est produite pendant la mise à jour du
statut RÉA-explAUR : ${r.data.err}.`
              }
            )
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Succès !',
                content: `Le changement de statut RÉA-explAUR a bien été effectué.`
              }
            )
          }
        }
      ).catch(
        e => {
          const str = e.status === 404 ? `Erreur 404` : e
          vm.busy = false
          vm.$notify(
            {
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une exception s'est produite pendant la mise à jour du
statut RÉA-explAUR : ${str}.`
            }
          )
        }
      )
    },

    notifySent: function () {
      this.confirm('écouvillons envoyés', 2)
    },

    notifyReceived: function () {
      this.confirm(`écouvillons reçus par l'établissement`, 3)
    },

    reset: function () {
      this.confirm(
        'inscrit (en attente du formulaire de destinataire des écouvillons)',
        0
      )
    }
  },

  computed: {
    dest: function () {
      return this.surveillance.modules.reaExplaur.dest
    },

    status: function () {
      return this.surveillance.modules.reaExplaur.stat.val
    },

    date: function () {
      const m = moment(this.surveillance.modules.reaExplaur.stat.date)
      return m.format('DD/MM/YYYY à HH:mm')
    },

    units: function () {
      const result = []
      const uy = units[this.surveillance.year]
      this.surveillance.modules.reaExplaur.srvs.forEach(
        u => {
          result.push(
            {
              name: u.uf.name,
              code: uy.codeFromIndex(u.uf.ufType),
              beds: u.prct.beds
            }
          )
        }
      )
      return result
    }
  },

  components: {
  }
}
</script>

<style lang="less" scoped>
@import '~variables';
table td:nth-of-type(1) {
  width: 20rem;
  font-weight: bold;
}

.alert {
  .btn:not(:first-child) {
    margin-left: 1rem;
  }
}

.rea-explaur-modal {
  & > h1, & > h2, & > h3, & > h4, & > h5 {
    color: @dark-base;
  }

  h1:first-child,
  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child {
    margin-top: 0rem;
    margin-bottom: 2rem;
  }

  .inline-radio {
    padding-left: 1rem;
  }
}

.alert-success small {
  color: white;
}

.button-list .btn {
  margin-right: 2rem;
}
</style>
